/**
 * Ce qu'une fiche collaborateur ENVOIE au serveur : uniquement les champs modifiés.
 *
 * L'enregistrement réécrivait la fiche entière (civilité, nom, email, téléphone, langues,
 * responsable…) quel que soit le champ touché. Deux conséquences :
 *  - le patron de l'incident AUVERGNE (un champ non édité réécrit à sa valeur locale,
 *    éventuellement périmée ou vide) ;
 *  - un MNG, qui n'a pas tous les droits, ne pouvait RIEN enregistrer : la moindre clé
 *    hors de son périmètre faisait refuser toute la requête.
 *
 * Partagé par l'édition globale (crayon) et l'édition d'un seul champ (double-clic).
 * Le profil n'y figure pas : il passe par son endpoint dédié (`/profile`).
 */

export const PATCHABLE_COLLABORATOR_FIELDS = [
  "civility",
  "firstName",
  "lastName",
  "email",
  "phoneNumber",
  "position",
  "linkedinUrl",
  "managerId",
  "language",
  "spokenLanguage",
] as const;

export type PatchableCollaboratorField = (typeof PATCHABLE_COLLABORATOR_FIELDS)[number];

type CollaboratorLike = Partial<Record<PatchableCollaboratorField, string | null | undefined>>;

/** `undefined`, `null` et `""` disent la même chose à l'écran : « vide ». */
function normalize(v: string | null | undefined): string | null {
  return v === undefined || v === null || v === "" ? null : v;
}

export function buildCollaboratorPatch(before: CollaboratorLike, after: CollaboratorLike): Partial<Record<PatchableCollaboratorField, string | null>> {
  const patch: Partial<Record<PatchableCollaboratorField, string | null>> = {};
  for (const field of PATCHABLE_COLLABORATOR_FIELDS) {
    const next = normalize(after[field]);
    if (normalize(before[field]) !== next) patch[field] = next;
  }
  return patch;
}
